import { fetchLegalNotices as fetchLegalNoticesApi } from 'support/api/LegalNoticesApi';
import { HttpClient } from 'support/api/api-types';

export const LEGAL_NOTICES = 'LEGAL_NOTICES' as const;
export const LEGAL_NOTICES_VALIDATED = 'LEGAL_NOTICES_VALIDATED' as const;

export const fetchLegalNotices = (url: string | null = null) => ({
  type: LEGAL_NOTICES,
  promise: (httpClient: HttpClient) => fetchLegalNoticesApi(httpClient, url),
});

export const validateLegalNotices = (isValid: boolean) => ({
  type: LEGAL_NOTICES_VALIDATED,
  payload: {
    isValid,
  },
});
